import { IDeleteContratoArquivoUseCase } from "../../../presentation/useCases/delete/delete_contrato_arquivo_use_case";
import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

// DeleteContratoArquivoUseCase

export class DeleteContratoArquivoUseCase implements IDeleteContratoArquivoUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async deleteContratoArquivo(IdContratoArquivo: number): Promise<void> {
    await this.repository.deleteContratoArquivo(IdContratoArquivo);
  }
}
